import { FilterValue } from "../Filters/FilterValue";
import { SortType } from "../SortType";

export interface PaymentLinkListItem {
  id: number;
  order_id: number;
  payment_link: string;
  amount: number;
  currency: string;
  status?: string | null;
  provider?: string | null;
  percentage?: number | null;
  created_date?: string | null;
  created_by_admin_name?: string | null;
}

export interface PaymentLinkFilters {
  page_no: number;
  limit: number;
  order_id?: string;
  status?: string;
  start_date?: string;
  end_date?: string;
  sort_by?: string;
  sort_type?: SortType;
}

export enum PaymentLinkFilterStatus {
  PAID = 1,
  UNPAID = 2,
  PARTIALLY_PAID = 3,
}

export const PAYMENT_LINK_STATUS_OPTIONS: FilterValue[] = [
  { id: "1", value: "Paid" },
  { id: "2", value: "Unpaid" },
  { id: "3", value: "Partially Paid" },
];

export const parsePaymentLinkStatusParam = (
  statusParam: string | null,
): FilterValue[] => {
  if (!statusParam) return [];
  return statusParam
    .split(",")
    .map((id) => PAYMENT_LINK_STATUS_OPTIONS.find((option) => option.id === id))
    .filter((item): item is FilterValue => item !== undefined);
};

export const formatPaymentLinkStatus = (status?: string | null): string => {
  if (!status) return "-";
  return status
    .replace(/_/g, " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
